import { render, staticRenderFns } from "./Notificacoes.vue?vue&type=template&id=1362ca20&scoped=true"
import script from "./Notificacoes.vue?vue&type=script&lang=js"
export * from "./Notificacoes.vue?vue&type=script&lang=js"
import style0 from "./Notificacoes.vue?vue&type=style&index=0&id=1362ca20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1362ca20",
  null
  
)

export default component.exports